var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 50,
  x: 1,
  y: 1,
  fill: "#F0F4F6",
  rx: 25
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 50,
  x: 1,
  y: 1,
  stroke: "#0B5745",
  strokeWidth: 2,
  rx: 25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0B5745",
  d: "M25.998 7.9c5.533 0 10.033 4.5 10.033 10.033s-4.5 10.032-10.033 10.032-10.032-4.5-10.032-10.032c0-5.533 4.5-10.033 10.032-10.033M25.998 48.03c-5.818 0-12.698-2.35-17.6-8.255a28.51 28.51 0 0 1 35.2 0c-4.901 5.905-11.78 8.255-17.6 8.255"
})));
export { SvgProfile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1MiA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgcng9IjI1IiBmaWxsPSIjRjBGNEY2Ii8+CiAgICA8cmVjdCB4PSIxIiB5PSIxIiB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHJ4PSIyNSIgc3Ryb2tlPSIjMEI1NzQ1IiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxwYXRoIGQ9Ik0yNS45OTg0IDcuODk5OUMzMS41MzA3IDcuODk5OSAzNi4wMzEgMTIuNDAwMiAzNi4wMzEgMTcuOTMyNUMzNi4wMzEgMjMuNDY0NyAzMS41MzA3IDI3Ljk2NSAyNS45OTg0IDI3Ljk2NUMyMC40NjYyIDI3Ljk2NSAxNS45NjU5IDIzLjQ2NDcgMTUuOTY1OSAxNy45MzI1QzE1Ljk2NTkgMTIuNDAwMiAyMC40NjYyIDcuODk5OSAyNS45OTg0IDcuODk5OVoiCiAgICAgICAgICBmaWxsPSIjMEI1NzQ1Ii8+CiAgICA8cGF0aCBkPSJNMjUuOTk4NCA0OC4wMzAyQzIwLjE3OTUgNDguMDMwMiAxMy4zMDAxIDQ1LjY3OTcgOC4zOTg0NCAzOS43NzQ4QzEzLjQxOTMgMzUuODM1NSAxOS42MTY2IDMzLjY5NDUgMjUuOTk4NCAzMy42OTQ1QzMyLjM4MDIgMzMuNjk0NSAzOC41Nzc2IDM1LjgzNTUgNDMuNTk4NCAzOS43NzQ4QzM4LjY5NjggNDUuNjc5NyAzMS44MTczIDQ4LjAzMDIgMjUuOTk4NCA0OC4wMzAyWiIKICAgICAgICAgIGZpbGw9IiMwQjU3NDUiLz4KPC9zdmc+Cg==";